import { render, staticRenderFns } from "./InterfaceTextEditor.vue?vue&type=template&id=2c1ad8e0"
import script from "./InterfaceTextEditor.vue?vue&type=script&lang=js"
export * from "./InterfaceTextEditor.vue?vue&type=script&lang=js"
import style0 from "./InterfaceTextEditor.vue?vue&type=style&index=0&id=2c1ad8e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports